var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#115BC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.738 11.3281L8.45703 8.04688M8.45738 11.3281L11.7383 8.04688",
    stroke: "white",
    strokeWidth: 0.820312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5664 9.6875C15.5664 6.66719 13.1179 4.21875 10.0977 4.21875C7.07735 4.21875 4.62891 6.66719 4.62891 9.6875C4.62891 12.7078 7.07735 15.1562 10.0977 15.1562C13.1179 15.1562 15.5664 12.7078 15.5664 9.6875Z",
    stroke: "white",
    strokeWidth: 0.820312
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.955115ef68a80efab3c6fe08817495d2.svg";
export { ForwardRef as ReactComponent };